import * as Sentry from '@sentry/react'
import { tokenizer } from '../../../utils'
import { config } from '../../../../components/Init/Init'
import firebase from 'firebase/compat/app'
import { useCallback, useEffect, useRef } from 'react'
import { usePlayerStore } from '../../../store'
import { useSetFirebaseToken } from '../../../store/playerStore/playerActions'

export const useRefreshFirebaseToken = setFirebaseCurrentUser => {
  const playerStore = usePlayerStore()
  const accessToken = playerStore.use.accessToken()
  const playerLoginUser = playerStore.use.loginUser()

  const { setFirebaseToken } = useSetFirebaseToken()

  const refreshFirebaseTokenRequestDataRef = useRef({
    accessToken: accessToken,
    accessEncryptedToken: accessToken.encryptedToken
  })

  useEffect(() => {
    refreshFirebaseTokenRequestDataRef.current = {
      accessToken: accessToken,
      accessEncryptedToken: accessToken.encryptedToken
    }
  }, [accessToken, accessToken.encryptedToken])

  const refreshFirebaseToken = useCallback(() => {
    console.log(
      'REFRESHING FIREBASE TOKEN - token data:',
      JSON.stringify(refreshFirebaseTokenRequestDataRef.current.accessToken)
    )

    return new Promise(function(resolve, reject) {
      fetch(
        tokenizer(config.apiUrl + config.firebaseAuthUrl, {
          '{userId}': playerLoginUser.userId
        }),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${refreshFirebaseTokenRequestDataRef.current.accessEncryptedToken}`
          }
        }
      )
        .then(response => {
          response
            .json()
            .then(async obj => {
              setFirebaseToken(obj.firebaseToken)

              try {
                await firebase
                  .auth()
                  .setPersistence(firebase.auth.Auth.Persistence.SESSION)
                  .catch(e => {
                    setFirebaseCurrentUser(null)
                    console.log(`[refreshFirebaseToken - ERROR] - setPersistence failed.`, e)
                    reject(e)
                  })

                await firebase
                  .auth()
                  .signInWithCustomToken(obj.firebaseToken)
                  .then(() => {
                    setFirebaseCurrentUser(firebase.auth().currentUser)
                  })
                  .catch(e => {
                    setFirebaseCurrentUser(null)
                    console.log(`[refreshFirebaseToken - ERROR] - signInWithCustomToken failed.`, e)
                    reject(e)
                  })

                resolve()
              } catch (err) {
                setFirebaseCurrentUser(null)
                console.log(`[refreshFirebaseToken - ERROR] - Firebase failure.`, err)
                reject(err)
              }
            })
            .catch(err => {
              setFirebaseCurrentUser(null)
              console.log(`[refreshFirebaseToken - ERROR] `, err)
              reject(err)
            })
        })
        .catch(err => {
          if (process.env.REACT_APP_ENABLE_SENTRY === 'true') {
            Sentry.captureException(err)
          }

          setFirebaseCurrentUser(null)
          console.log(`[refreshFirebaseToken - ERROR] ${err.code} - ${err.message}`)
          reject(err)
        })
    })
  }, [playerLoginUser.userId, accessToken.encryptedToken, setFirebaseToken, setFirebaseCurrentUser])

  return { refreshFirebaseToken }
}
